<div class="opath-editor-navigation-container" #test>
  <opath-core-nav-header
    [title]="translation.attribute.title"
    [buttons]="entityButtons"
    [height]="100"
    (onFilterOptionChanged)="filterOptionChanged($event)"
    (onSearchTermChanged)="searchTermChanged($event)"
    (onbuttonStateChanged)="refreshButtonsState()"
    >
  </opath-core-nav-header>
  <div class="opath-editor-navigation-body">
    <dx-scroll-view #scroller>
      @for (tree of rootTreeNodes; track tree) {
        <abc-accordion
          [collapsible]="true"
          [dataSource]="rootTreeNodes"
          [collapsible]="true"
          [multiple]="false"
          [animationDuration]="300"
          class="expansion-panel"
          >
          <div class="tree-caption" *dxTemplate="let tree of 'title'">
            {{ tree.caption }}
          </div>
          <div *dxTemplate="let tree of 'item'">
            <abc-tree
              class="tree"
              #entityTree
              [useNativeScrolling]="true"
              [searchEnabled]="false"
              [searchValue]="searchTerm"
              [searchMode]="currentFilterOption?.searchMode"
              hasItemsExpr="children"
              [keyExpr]="tree.children.id"
              [data]="tree.children"
              (onItemClick)="onItemClick($event)"
              (onItemExpanded)="onItemExpanded($event)"
              [itemTemplate]="''"
              >
              <div *dxTemplate="let node of ''">
                <div class="tree-node-custom-item" [title]="node.caption">
                  <mat-icon [svgIcon]="node.icon"></mat-icon>
                  <span>{{ node.caption }}</span>
                </div>
              </div>
            </abc-tree>
          </div>
        </abc-accordion>
      }
    </dx-scroll-view>
  </div>
</div>
